// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import type { Theme } from '../../../theme/Theme';

export const getTableStyles = (theme: Theme) => ({
  root: {
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  minWidth: {
    minWidth: '0',
  },
  alwaysVisible: {
    display: 'flex',
  },
  baseRow: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 48,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  wrapText: {
    whiteSpace: 'normal',
    overflow: 'wrap',
    textOverflow: 'wrap',
  },
  // This class is also used in AddOrderChangesTable.tsx
  row: {
    fontFamily: 'fontFamily',
    fontSize: 14,
    fontWeight: 'fontWeightRegular',
    color: 'text.primary',
  },
  headerRow: {
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
  },
  header: {
    fontFamily: 'fontFamily',
    fontSize: 16,
    fontWeight: 'fontWeightMedium',
    color: 'text.secondary',
  },
  textRowBase: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  oddRow: {
    bgcolor: theme.custom.colors.common.oddRow,
  },
  numeric: {
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  paddingLeft: {
    paddingLeft: {
      xs: 1,
      sm: 3,
      md: 5,
    },
  },
  firstCol: {
    paddingLeft: {
      xs: 1,
      sm: 2,
    },
  },
});
